/**
 * API接口配置
 * 本文件聚合所有API接口配置，提供统一的导出入口
 */

// 导出类型定义
export type { ApiParameter, ResponseField, ApiEndpoint } from './types';

// 导出常量
export { API_CATEGORIES } from './constants';

// 导出工具函数
export { getApisByCategory, getApiById, getAllCategories } from './utils';

// 导入所有接口配置
import { authEndpoints } from './endpoints/auth';
import { spaceEndpoints } from './endpoints/space';
import { tagEndpoints } from './endpoints/tag';
import { coordinateEndpoints } from './endpoints/coordinate';
import { displayEndpoints } from './endpoints/display';
import { drawingEndpoints } from './endpoints/drawing';
import { markerEndpoints } from './endpoints/marker';
import { uploadEndpoints } from './endpoints/upload';
import { serviceEndpoints } from './endpoints/service';

// 聚合所有接口配置
export const API_ENDPOINTS = [
  ...authEndpoints,
  ...spaceEndpoints,
  ...tagEndpoints,
  ...coordinateEndpoints,
  ...displayEndpoints,
  ...drawingEndpoints,
  ...markerEndpoints,
  ...uploadEndpoints,
  ...serviceEndpoints,
];

